import styled from 'styled-components';

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(36, 36, 36, 0.3);
  backdrop-filter: blur(3px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
`;

export const ModalContent = styled.div`
  background: white;
  width: 800px; /* Ajuste se necessário */
  max-height: 90vh; /* Para garantir que não fique maior que a tela */
  overflow-y: auto; /* Adiciona scroll se o conteúdo for muito grande */
  padding: 30px;
  border-radius: 20px;
  box-shadow: 0px 4px 30px rgba(0, 0, 0, 0.1);
  position: relative;
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`;

export const ModalTitle = styled.h2`
  font-size: 20px;
  font-weight: 600;
  color: #202020;
  margin: 0;
`;

// MUDANÇA AQUI: Estilização do CloseButton para padronizar com o de Novo Produto
export const CloseButton = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  width: 40px; // Padronizado
  height: 40px; // Padronizado
  border-radius: 50%; // Padronizado
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 27px; // Padronizado para o tamanho da imagem do ícone
    height: 27px; // Padronizado para o tamanho da imagem do ícone
  }

  &:hover {
    background-color: #f1f1f1; // Padronizado
  }
`;

export const ModalBody = styled.div`
  margin-bottom: 20px;
`;

export const InfoRow = styled.div`
  display: flex;
  margin-bottom: 10px;
`;

export const InfoLabel = styled.span`
  font-weight: 600;
  color: #555;
  width: 120px; /* Largura fixa para os rótulos */
  flex-shrink: 0;
`;

export const InfoValue = styled.span`
  color: #202020;
  flex-grow: 1;
`;